import { render, staticRenderFns } from "./GeneralSearch.vue?vue&type=template&id=61ae8354&"
import script from "./GeneralSearch.vue?vue&type=script&lang=js&"
export * from "./GeneralSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports